import React from 'react';
import { string } from 'prop-types';
import LocalizedLink from './LocalizedLink';

const Button = ({ to, label, className }) => {
  return (
    <LocalizedLink
      className={`py-6 bg-light-100 text-light-700 text-lg font-bold shadow-xl rounded uppercase no-underline ${className}`}
      to={to}
    >
      {label}
    </LocalizedLink>
  );
};

Button.propTypes = {
  to: string,
  label: string,
  className: string,
};

Button.defaultProps = {
  to: null,
  label: null,
  className: null,
};

export default Button;
